import React from "react";
import homeimage from "../Assests/newprofile.png";
import homeimage_remove from "../Assests/photoabout2.png";
import { Box, Image } from "@chakra-ui/react";
import Type from "../Compo/Homes/Type";
import { MdArrowForward } from "react-icons/md";
const HomeNew = () => {
  return (
    <section className="hero" id="home" aria-label="home">
      <div className="container">
        <div className="hero-content">
          <h3 className="hello">Full stack mern developer</h3>
          <p className="hero-subtitle">
            Hello Everyone! <span className="wave">👋🏻</span>
          </p>

          <h1 className="headline headline-1 section-title">
            I’m <span className="span">Disha Gupta</span>
          </h1>

          <p className="hero-text">
            <Type />
          </p>

          <div className="input-wrapper">
            <button className="btn btn-primary">
              <span className="span">Connect</span>

              <MdArrowForward />
            </button>
            <a
              href="https://wa.me/9084360292"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25"
                height="25"
                src="https://img.icons8.com/color/48/whatsapp--v1.png"
                alt="whatsapp--v1"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/disha-gupta-303b971a3/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25"
                height="25"
                src="https://img.icons8.com/color/48/linkedin.png"
                alt="linkedin"
              />
            </a>
            <a
              href="https://github.com/DishaGup"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25"
                height="25"
                src="https://img.icons8.com/color/48/github--v1.png"
                alt="github--v1"
              />
            </a>
            <a href="mailto:guptamansi201@gmail.com">
              <img
                width="25"
                height="25"
                src="https://img.icons8.com/color/48/gmail-new.png"
                alt="gmail-new"
              />{" "}
            </a>
          </div>
        </div>

        <Box className="hero-banner">
          <Image
            src={homeimage}
            display={{ base: "none", lg: "block" }}
            className="w-100"
            objectFit={"cover"}
            objectPosition={"center"}
            height="490"
            alt="Disha Gupta"
            borderRadius={"50%"}
          />
          {/* <Image mb='-80px' zIndex={-1} transform="rotate(38deg)" src={homeimage_remove} overflow={'hidden'} display={{base:'block',lg:"none"}} objectFit={'cover'} objectPosition={'top'} height="390" alt="Disha Gupta" /> */}
          <Image
            style={{
              filter: "contrast(105%) brightness(105%)", // Adjust the values as needed
            }}
            zIndex={-1}
            src={homeimage_remove}
            w="70%"
            m="auto"
            overflow={"hidden"}
            display={{ base: "block", lg: "none" }}
            borderRadius={"30px"}
            objectFit={"cover"}
            objectPosition={"center"}
            height="390"
            alt="Disha Gupta"
          />
        </Box>
      </div>
    </section>
  );
};

export default HomeNew;
